import { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtDateDay, fmtDate } from "@/lib/dates";
import { Card } from "@/components/ui/card";
import { Megaphone, CalendarDays, Clock, MapPin, Bell } from "lucide-react";

function EventRow({ e }) {
  return (
    <li className="p-5" data-testid={`portal-event-${e.id}`}>
      <p className="font-medium text-[#1C241B]">{e.title}</p>
      <div className="mt-1 flex flex-wrap gap-x-4 gap-y-1 text-xs text-[#7A8A78]">
        <span className="flex items-center gap-1"><CalendarDays className="h-3.5 w-3.5" />{fmtDateDay(e.date)}</span>
        {e.time && <span className="flex items-center gap-1"><Clock className="h-3.5 w-3.5" />{e.time}</span>}
        {e.location && <span className="flex items-center gap-1"><MapPin className="h-3.5 w-3.5" />{e.location}</span>}
      </div>
      {e.description && <p className="mt-1.5 text-sm text-[#526050] whitespace-pre-line">{e.description}</p>}
    </li>
  );
}

function NoticeRow({ n }) {
  return (
    <li className="p-5" data-testid={`portal-notice-${n.id}`}>
      <p className="font-medium text-[#1C241B]">{n.title}</p>
      {n.date && <p className="mt-0.5 text-xs text-[#7A8A78]">{fmtDate(n.date)}</p>}
      {n.description && <p className="mt-1.5 text-sm text-[#526050] whitespace-pre-line">{n.description}</p>}
    </li>
  );
}

const Section = ({ icon: Icon, title, color, children, testid, empty }) => (
  <div data-testid={testid}>
    <div className="flex items-center gap-2 px-5 py-3 bg-[#F7F5F0] border-b border-[#E5E0D8]">
      <Icon className="h-4 w-4" style={{ color }} />
      <h3 className="font-serif text-lg font-bold text-[#1C241B]">{title}</h3>
    </div>
    <ul className="divide-y divide-[#E5E0D8]">
      {children.length ? children : <li className="p-6 text-center text-sm text-[#7A8A78]">{empty}</li>}
    </ul>
  </div>
);

export const MyAnnouncements = () => {
  const [data, setData] = useState({ events: [], notices: [] });
  useEffect(() => { api.get("/me/announcements").then((r) => setData(r.data)).catch(() => {}); }, []);

  return (
    <Card className="bg-white border border-[#E5E0D8] shadow-sm overflow-hidden" data-testid="portal-announcements">
      <div className="flex items-center gap-2 p-5 border-b border-[#E5E0D8]">
        <Megaphone className="h-5 w-5 text-[#9A3412]" />
        <h2 className="font-serif text-xl font-semibold">Events & Announcements</h2>
      </div>
      <Section icon={CalendarDays} title="Upcoming Events" color="#2D5A27" testid="portal-events" empty="No upcoming events.">
        {data.events.map((e) => <EventRow key={e.id} e={e} />)}
      </Section>
      <Section icon={Bell} title="Announcements" color="#D97706" testid="portal-notices" empty="No announcements right now.">
        {data.notices.map((n) => <NoticeRow key={n.id} n={n} />)}
      </Section>
    </Card>
  );
};
